import { Button } from '../../../../components/Toolkit/Button/Button';
import { FilterVerticalIc } from '@dsch/dd-icons';

export interface IFilterButtonProps {
  filterCount: number;
  onClick: () => void;
}

function FilterButton({ onClick, filterCount }: IFilterButtonProps) {
  return (
    <Button
      data-testid="filter-button"
      icon={<FilterVerticalIc />}
      onClick={onClick}
    >
      Filter{!!filterCount && `s (${filterCount})`}
    </Button>
  );
}

export { FilterButton };
